import {
  ApplicationConfig,
  importProvidersFrom,
  ErrorHandler,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
  ValueProvider
} from '@angular/core';
import {HttpClient, provideHttpClient, withFetch} from '@angular/common/http';
import {provideTranslateService, TranslateLoader} from '@ngx-translate/core';
import {localizationHttpLoaderFactory} from './translate/factory/translate-http-loader.factory';
import * as Sentry from "@sentry/angular";
import {Router} from '@angular/router';
import {BrowserModule} from '@angular/platform-browser';

const provideWindow = (): ValueProvider => {
  return {provide: Window, useValue: window};
};

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(BrowserModule),
    provideZoneChangeDetection({eventCoalescing: true}),
    provideHttpClient(withFetch()),
    provideWindow(),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler()
    },
    {
      provide: Sentry.TraceService,
      deps: [Router]
    },
    ...provideTranslateService({
      loader: { provide: TranslateLoader, useFactory: localizationHttpLoaderFactory, deps: [HttpClient]}
    }),
    provideAppInitializer(() => {
      inject(Sentry.TraceService);
    })
  ]
};
